import logo from "../../../../assets/logo-main.svg";
import googlePlay from "../../../../assets/images/google_play.svg";
import appStore from "../../../../assets/images/app_store.svg";
import MessageIcon from "../../../../assets/images/MessageIcon.svg";
import twitter from "../../../../assets/images/social_icon_1.svg";
import insta from "../../../../assets/images/social_icon_2.svg";
import linkedIn from "../../../../assets/images/social_icon_3.svg";
import { Link } from "react-router-dom";
import { allRoutes } from "../../../../routes/routes";

const FooterSection = () => {
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <footer 
     id="footer"
      className="footer-main-box "
      style={{
        backgroundColor: "#161616",
        color: "#fff",
      }}
    >
      <div className="max-width-custom">
        <div className="container">
          {/* Top Row */}
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-5 mb-md-4">
            <img src={logo} alt="DoxBox Logo" className="logo-footer" />
            <div className="d-flex align-items-center gap-2">
              <a
                href="https://ios.doxboxapp.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={appStore} alt="App Store" className="apps-store" />
              </a>

              <a
                href="https://android.doxboxapp.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={googlePlay} alt="Google Play" className="apps-store" />
              </a>
            </div>
          </div>

          {/* Divider Line */}
          <hr className="d-none d-sm-block border-secondary my-5" />

          {/* Middle Row */}
          <div className="mt-4 text-white">
            <div className="row">
              {/* Section Headings */}
              <div className="col-6">
                <h5 className="footer-heading pb-3 fs-responsive">
                  Quick Links
                </h5>
              </div>
              <div className="col-6 d-flex justify-content-end gap-2">
                <img
                  src={MessageIcon}
                  alt="Contact Icon"
                  style={{ height: "22px" }}
                  className="mssg-icon"
                />
                <h5 className="mb-0 fs-responsive">Contact Us</h5>
              </div>
            </div>

            {/* Row 1: Features | Email */}
            <div className="d-flex justify-content-between">
              <a
                onClick={() => scrollToSection("features")}
                className="fs-responsive text-decoration-none"
                role="button"
                style={{ color: "#BFC6D6" }}
              >
                Features
              </a>
              <div className="text-end">
                <span className="fs-responsive" style={{ color: "#BFC6D6" }}>
                  Email:{" "}
                  <a
                    href="mailto:contact@doxboxapp.com"
                    className="text-decoration-none text-white"
                  >
                    contact@doxboxapp.com
                  </a>
                </span>
              </div>
            </div>

            {/* Row 2: Why DOXBOX! | Legal */}
            <div className="d-flex justify-content-between mt-3">
              <a
                onClick={() => scrollToSection("why-doxbox")}
                className="fs-responsive text-decoration-none"
                role="button"
                style={{ color: "#BFC6D6" }}
              >
                Why DOXBOX!
              </a>
              <div className=" d-flex justify-content-end align-items-center gap-2 fs-responsive">
                <Link
                  target="_blank"
                  to="/privacy-policy"
                  className="text-decoration-none"
                  style={{ color: "#BFC6D6" }}
                >
                  Privacy Policy
                </Link>
                <span className="text-white">|</span>
                <Link
                  target="_blank"
                  to="/terms-of-use"
                  className="text-decoration-none"
                  style={{ color: "#BFC6D6" }}
                >
                  Terms of Use
                </Link>
                <span className="text-white">|</span>
                <Link
                  to={allRoutes.deleteMyApp}
                  className="text-decoration-none"
                  style={{ color: "#BFC6D6" }}
                >
                  Delete My Data
                </Link>
              </div>
            </div>
          </div>

          {/* Divider Line */}
          <hr className="d-block d-sm-none border-secondary mt-5 mb-3" />

          {/* Bottom Row */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mt-4 mt-md-5 gap-3 text-white">
            {/* Left: Text */}
            <p className="mb-0 small">Copyright © DoxBox</p>

            {/* Right: Social Icons */}
            <div className="d-flex align-items-center gap-3">
              <img src={insta} alt="Instagram" style={{ height: "20px" }} />
              <img
                src={twitter}
                alt="Twitter"
                style={{ height: "20px", transform: "scale(1.26)" }}
              />
              <img src={linkedIn} alt="LinkedIn" style={{ height: "20px", transform: "scale(1.3)" }} />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
